export default {
  leastDrawn: 'Наименее выпадавшие',
  mostDrawn: 'Наиболее выпадавшие',
  leastPlayed: 'Наименее сыгранные',
  mostPlayed: 'Наиболее сыгранные',
  drawFrom: 'Тираж из',
  h: 'ч', // сокращение для часов
  startingIn: 'Начинается через',
  waitingForDrawnFrom: 'Ожидание тиража из',
  displayingDrawFrom: 'Отображение тиража из',
  lotteryDraw: 'Лотерейный тираж',
  eventId: 'ID события',
  bettingShortcuts: 'Сокращения для ставок',
  draw: 'Тираж',
  next5Events: 'Следующие {value} отображаются',
  events: 'События',
  schedule: 'Расписание',
  next: 'Следующий',
  event: 'Событие',
  later: 'Позже',
  statistics: 'Статистика',
  lastnRounds: 'Последние {value} раундов',
  bettingOffer: 'Предложение для ставок',
  notDisplayed: 'Не отображается',
  latestResults: 'Последние результаты',
  drawnAt: 'Выпало в {value}',
  additionalBetting: 'Дополнительные ставки',
  drawSumEvenOdd: 'Сумма розыгрыша чёт или нечёт',
  drawSumTotal: 'Общая сумма розыгрыша',
  drawSumRange: 'Диапазон суммы розыгрыша',
  waitingForDrawNo: 'Ожидание розыгрыша №{value}',
  nextDraw: 'Следующий розыгрыш',
  waitingForDraw: 'Ожидание розыгрыша',
  drawCompleted: 'Розыгрыш завершён',
  drawDisplayTemporarilyNotAvailable: 'Отображение розыгрыша временно недоступно',
  connectionError: 'Ошибка соединения!',
  reconnecting: 'Повторное подключение...',
  number: 'Число',
  headerNumberDescriptionUp: 'Событие',
  headerNumberDescriptionDown: 'Число',
};
